import { useTranslation } from "react-i18next";

export const useTranslateData = () => {
  const { t } = useTranslation();
  return [
    {
      id: "proxy",
      key: t("anonymityCheck.hostInfo.proxy"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "vpn",
      key: t("anonymityCheck.hostInfo.vpn"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "tor",
      key: t("anonymityCheck.hostInfo.tor"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "anonymizer",
      key: t("anonymityCheck.hostInfo.anonymizer"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "blacklist",
      key: t("anonymityCheck.hostInfo.blacklist"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "flash",
      key: t("anonymityCheck.hostInfo.flash"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "java",
      key: t("anonymityCheck.hostInfo.java"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "activeX",
      key: t("anonymityCheck.hostInfo.activeX"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "webRtc",
      key: t("anonymityCheck.hostInfo.WebRTC"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "webRtcIps",
      key: t("anonymityCheck.hostInfo.WebRTCIPs"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "existOpenPorts",
      key: t("anonymityCheck.hostInfo.openPorts"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
    {
      id: "blacklist_check",
      key: t("anonymityCheck.hostInfo.blacklist2"),
      label: "",
      value: "-",
      labelStatus: false,
      between: true,
    },
  ];
};
